import { brand } from "../brand";
import { cn } from "../lib/utils";

// A brand's logo: its two-part wordmark in the OptimusBytes family style (as on optimusfitness.app: a red and a blue
// block with cut corners), or its name in the heading style when it has none. The wordmark keeps its own colours in
// both themes. `of` is a brands.json entry, the deployment's brand by default.
const SIZES = { sm: "text-sm", md: "text-base", lg: "text-xl", xl: "text-2xl" };
const BLOCK = "px-[0.5em] pt-[0.3em] pb-[0.34em]";
const CUT_TOP_LEFT = "[clip-path:polygon(0.4em_0,100%_0,100%_100%,0_100%,0_0.4em)]";
const CUT_BOTTOM_RIGHT = "[clip-path:polygon(0_0,100%_0,100%_calc(100%_-_0.4em),calc(100%_-_0.4em)_100%,0_100%)]";

export function BrandLogo({ of = brand, size = "md", className }) {
  if (!of.wordmark) {
    return (
      <span className={cn("font-heading font-black uppercase tracking-wider text-primary", SIZES[size], className)}>
        {of.name}
      </span>
    );
  }
  const [first, second] = of.wordmark.parts;
  const [firstColor, secondColor] = of.wordmark.colors;
  return (
    <span
      role="img"
      aria-label={of.name}
      className={cn(
        "inline-flex gap-[0.12em] whitespace-nowrap font-heading font-bold uppercase leading-none tracking-[0.06em] text-white",
        SIZES[size],
        className,
      )}
    >
      <span aria-hidden="true" className={cn(BLOCK, CUT_TOP_LEFT)} style={{ background: firstColor }}>{first}</span>
      <span aria-hidden="true" className={cn(BLOCK, CUT_BOTTOM_RIGHT)} style={{ background: secondColor }}>{second}</span>
    </span>
  );
}
